import {ListFilterCheckboxSection} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {TEAM_ROLE_FILTER_OPTIONS} from '../../config/team-filter.config';

import type {FC} from 'react';

export interface TeamFilterRoleSectionProps {
  roleKeys: string[];
  onChange: (roleKeys: string[]) => void;
}

export const TeamFilterRoleSection: FC<TeamFilterRoleSectionProps> = ({roleKeys, onChange}) => {
  const {t} = useTranslation(['team', 'common']);

  const options = TEAM_ROLE_FILTER_OPTIONS.map(value => ({
    value,
    label: t(`common:roles.${value}`)
  }));

  return (
    <ListFilterCheckboxSection
      title={t('filter.sections.role')}
      options={options}
      selected={roleKeys}
      onChange={onChange}
    />
  );
};
